import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { QueryRoute } from '@/lib/api/queryApi'
import { createId } from '@/lib/utils/id'

/** Bounded so localStorage can't grow without limit across sessions. */
const MAX_ENTRIES = 250

export interface HistoryEntry {
  id: string
  query: string
  conversationId: string
  route: QueryRoute
  at: number
  status: 'success' | 'error'
  rowCount?: number
  durationMs?: number
  errorMessage?: string
}

export interface HistoryState {
  entries: HistoryEntry[]
  record: (entry: Omit<HistoryEntry, 'id' | 'at'>) => void
  remove: (id: string) => void
  clear: () => void
}

export const useHistoryStore = create<HistoryState>()(
  persist(
    (set) => ({
      entries: [],

      record: (entry) =>
        set((state) => ({
          entries: [
            { ...entry, id: createId(), at: Date.now() },
            ...state.entries,
          ].slice(0, MAX_ENTRIES),
        })),

      remove: (id) =>
        set((state) => ({
          entries: state.entries.filter((entry) => entry.id !== id),
        })),

      clear: () => set({ entries: [] }),
    }),
    { name: 'qap.history.v1', version: 1 },
  ),
)
